/**
 * These might be better done iun the template with some kind of preprocess, but this works for now.
 */
(function ($) {
  document.addEventListener("DOMContentLoaded", function () {
    // Add next-block prop to hero
    (function () {
      let hero = document.querySelector(".section--hero");
      if (!hero) return;

      // Get the first .section in .node-sections, and gind the class that starts bg-
      let firstSections = document.querySelectorAll(
        ".node-sections .section:first-child",
      );
      firstSections.forEach((section) => {
        let classes = section.className.split(" ");
        let bgClass = classes.find((c) => c.startsWith("bg-")) || "bg-white";
        let colorClass = bgClass.replace("bg-", "color-");
        // Add the prop to .section--hero as
        hero.style.setProperty("--next-block-bg", `var(--${colorClass})`);
      });
    })();

    // Forcibly removes .has-after-mask from the last .section in
    // .node-sections, unless it's a .bg-image section with its own
    // before mask, in which case that mask should stay.
    let lastSections = document.querySelectorAll(
      ".node-sections .section:last-child",
    );
    lastSections.forEach((section) => {
      if (
        (section.classList.contains("bg-image") &&
          section.classList.contains("has-before-mask")) ||
        section.classList.contains("section--featured-content")
      ) {
        return;
      }
      section.classList.remove("has-after-mask");
    });

    // If the last .section in .node-sections has a background image
    // (.bg-image), the footer's before mask would render on top of it, so
    // always remove it, regardless of that section's own mask state.
    let footer = document.querySelector(".site-footer");
    let lastSection = document.querySelector(
      ".node-sections > .section:last-child",
    );

    // Set the footer's --previous-block-bg to the last .section's computed
    // --color-section-background, so its before mask blends into that section.
    if (footer && lastSection) {
      let sectionBg = getComputedStyle(lastSection)
        .getPropertyValue("--color-section-background")
        .trim();
      if (sectionBg) {
        footer.style.setProperty("--previous-block-bg", sectionBg);
      }
    }

    if (footer && lastSection && lastSection.classList.contains("bg-image")) {
      footer.classList.remove("has-before-mask");
    }

    if (
      footer &&
      lastSection &&
      lastSection.classList.contains("section--featured-content")
    ) {
      footer.classList.remove("has-before-mask");
      lastSection.classList.add("has-after-mask");
    }

    // Webform pages don't have a .node-sections wrapper before the footer,
    // so always remove the footer's before mask on them.
    if (footer && document.body.classList.contains("page-node-type-webform")) {
      footer.classList.remove("has-before-mask");
    }
  });
})(jQuery);
